// Account Dropdown JavaScript
document.addEventListener('DOMContentLoaded', function() {
  const dropdownContainer = document.querySelector('.profile-dropdown');
  const dropdownToggle = document.querySelector('.account-dropdown-toggle');
  const dropdownMenu = document.querySelector('.account-dropdown-menu');
  
  if (!dropdownToggle || !dropdownMenu) return;

  function isDesktop() {
    return window.innerWidth > 749;
  }
  
  // Toggle dropdown
  dropdownContainer.addEventListener('mouseenter', function(e) {
    if (!isDesktop()) return;
    e.preventDefault();
    e.stopPropagation();
    
    const isExpanded = dropdownToggle.getAttribute('aria-expanded') === 'true';
    
    dropdownToggle.setAttribute('aria-expanded', !isExpanded);
    dropdownMenu.setAttribute('aria-hidden', isExpanded);
  });
  
  // Close dropdown when clicking outside
  dropdownContainer.addEventListener('mouseleave', function(e) {
    if (!isDesktop()) return;
    if (!dropdownToggle.contains(e.target) && !dropdownMenu.contains(e.target)) {
      dropdownToggle.setAttribute('aria-expanded', 'false');
      dropdownMenu.setAttribute('aria-hidden', 'true');
    }
  });
  
  // Close dropdown on escape key
  document.addEventListener('keydown', function(e) {
    if (!isDesktop()) return;
    if (e.key === 'Escape') {
      dropdownToggle.setAttribute('aria-expanded', 'false');
      dropdownMenu.setAttribute('aria-hidden', 'true');
      dropdownToggle.focus();
    }
  });  
});